<template>
  <div>
   <el-button @click="resetDateFilter">清除日期过滤器</el-button>
      <el-button @click="clearFilter">清除所有过滤器</el-button>
      <el-table
        ref="filterTable"
        :data="tableData"
        style="width: 100%"
        height="800"
      >
        <el-table-column
          prop="start"
          label="日期"
          sortable
          column-key="date"
          :filters="filtersDate"
          :filter-method="filterHandler"
        >
        </el-table-column>
        <el-table-column
          prop="numbers"
          label="制令单号"
          :filters="filtersNumber"
          :filter-method="filterHandler"
        >
        </el-table-column>
        <el-table-column
          prop="model"
          label="零件名称"
          :filters="filtersModel"
          :filter-method="filterHandler"
        >
        </el-table-column>
          <el-table-column
          prop="output"
          label="计划产量"
          >
        </el-table-column>
        <el-table-column
          prop="status"
          label="生产状态"
          width="180"
          :filters="filtersState"
          :filter-method="filterTag"
          filter-placement="bottom-end">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.status === '已完成' ? 'success' : scope.row.status === '未完成' ? 'danger' : scope.row.status === '计划实施中' ? 'warning' : 'primary'"
              disable-transitions>{{scope.row.status}}</el-tag>
          </template>
        </el-table-column>
      </el-table>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        filtersDate: [],
        filtersState: [],
        filtersNumber: [],
        filtersModel: [],
        tableData: [],
        //   filtersDate: [{text: '2016-05-01', value: '2016-05-01'},
        //       {text: '2016-05-02', value: '2016-05-02'},
        //       {text: '2016-05-03', value: '2016-05-03'},
        //       {text: '2016-05-04', value: '2016-05-04'}
        // ],
        // filtersState: [
        //     { text: '计划实施中', value: '计划实施中'},
        //     { text: '计划未实施', value: '计划未实施'},
        //     { text: '未完成', value: '未完成'},
        //     { text: '已完成', value: '已完成'},
        // ],
        // filtersNumber: [
        //     { text: '0015A', value: '0015A'},
        //     { text: '0015B', value: '0015B'},
        //     { text: '0016A', value: '0016A'},
        //     { text: '0055D', value: '0055D'},
        // ],
        // filtersModel: [
        //     { text: 'D02锅底', value: 'D02锅底'},
        //     { text: 'F08锅', value: 'F08锅'},
        //     { text: 'D04锅底', value: 'D04锅底'},
        // ],
        // tableData: [{
        //   start: '2016-05-02',
        //   numbers: '0015A',
        //   model: 'D02锅底',
        //   output: 10000,
        //   status: '计划未实施',
        // }, {
        //   start: '2016-05-04',
        //   numbers: '0015B',
        //   model: 'D02锅底',
        //   output: 50000,
        //   status: '计划实施中'
        // }, {
        //   start: '2016-05-01',
        //   numbers: '0016A',
        //   model: 'F08锅',
        //   output: 1000,
        //   status: '已完成'
        // }, {
        //   start: '2016-05-03',
        //   numbers: '0055D',
        //   model: 'D04锅底',
        //   output: 2000,
        //   status: '未完成'
        // }]
      }
    },
    created() {
      this.getCalendar(); // 读取后端数据
    },
    methods: {
      resetDateFilter() {
        this.$refs.filterTable.clearFilter('date');
      },
      clearFilter() {
        this.$refs.filterTable.clearFilter();
      },
      formatter(row, column) {
        return row.address;
      },
      filterTag(value, row) {
        return row.status === value;
      },
      filterHandler(value, row, column) {
        const property = column['property'];
        return row[property] === value;
      },

      // 读取后端数据
      async getCalendar(){
        const { data: res } = await this.axios.get("/planlist");
        if(res.meta.status === 200){
            this.filtersDate = res.data.filtersDate; // 日期
            this.filtersModel = res.data.filtersModel; // 零件名称
            this.filtersNumber = res.data.filtersNumber; // 制令单号
            this.filtersState = res.data.filtersState; // 计划状态
            this.tableData = res.data.tableData; // 数据列表
        }
      }
    }
  }
</script>

<style lang="less" scoped>
@import url("//unpkg.com/element-ui@2.14.1/lib/theme-chalk/index.css");
</style>